import { Card } from "./card";

export class Pioche {
    stack: Card[] = [];
    discard: Card[] = [];
    choosenCard: Card | undefined = undefined

    constructor() {
        this.stack = [-2, -2, -2, -2, -2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12].map((value, id) => new Card(value, id + 1));

        this.shuffle()
        let card = this.stack.pop()
        if (card) {
            card.show = true
            this.discard.push(card)
        }
    }

    takeFromStack(): Card | undefined {
        let card = this.stack.pop()
        if (!card)
            return
        if (this.stack.length === 0) {
            this.stack = this.discard
            this.discard = []
            this.shuffle()
        }
        return card
    }

    lastCardFromStack(): Card {
        return this.stack.slice(-1)[0]
    }

    takeFromDiscard(): Card | undefined {
        let card = this.discard.pop()
        if (!card)
            return
        return card
    }

    lastCardFromDiscard(): Card {
        return this.discard.slice(-1)[0]
    }

    shuffle() {
        let currentIndex = this.stack.length, randomIndex;

        while (currentIndex != 0) {

            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            [this.stack[currentIndex], this.stack[randomIndex]] = [
                this.stack[randomIndex], this.stack[currentIndex]];
        }
    }
}
